import React from 'react';
import { useTranslation } from 'react-i18next';
import { CountryCode } from '../../models/country';
import { AutocompleteInput } from './autocompleteInput';
import { COUNTRY_OPTIONS } from './countryOptions';

export type CountryAutocompleteProps = {
  label?: string;
  value?: CountryCode | string | null;
  onChange: (code: CountryCode) => void;
  onClick?: React.MouseEventHandler;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
};

export const CountryAutocomplete: React.FC<CountryAutocompleteProps> = ({
  label,
  value,
  onChange,
  onClick,
  size = 'small',
  fullWidth = true,
  error,
  helperText,
  required,
}) => {
  const { t } = useTranslation();

  return (
    <AutocompleteInput
      label={label ?? t('Country')}
      options={COUNTRY_OPTIONS}
      value={value as CountryCode}
      onChange={onChange}
      size={size}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      required={required}
      onClick={onClick}
    />
  );
};
